export abstract class InitializeField<T> {
  protected abstract excludedKeys: string[];

  protected initializeFields(data: Partial<T>): void {
    if (!data) {
      console.warn('Data is null or undefined. Default values will be used.');
      data = {};
    }

    Object.keys(this).forEach((key) => {
      const value = (data as any)[key];
      (this as any)[key] =
        value !== undefined ? value : this.getDefaultValue(key);
    });
  }

  protected mapToModelArray<T, M>(
    items: T[] | undefined,
    Model: new (data: Partial<T>) => M,
  ): M[] {
    return items ? items.map((item) => new Model(item)) : [];
  }

  protected abstract getDefaultValue(key: string): any;
}
